import { AxiosInstance } from 'axios';
import { ClaimUserVerificationCodeInput, GenerateUserVerificationCodeInput } from './inputs';
import { UserVerificationCodeRef } from './refs';

export default class UserVerificationCode {
    private basePath = '/rest/user-verification-code';
    private http: AxiosInstance;

    constructor(http: AxiosInstance) {
        this.http = http;
    }

    // Generate new verification code'
    generate = async (input: GenerateUserVerificationCodeInput): Promise<UserVerificationCodeRef> => {
        const { data } = await this.http.post(`${this.basePath}/`, input);

        return data;
    };

    // Claim verification code
    claim = async (id: ID, input: ClaimUserVerificationCodeInput): Promise<UserVerificationCodeRef> => {
        const { data } = await this.http.post(`${this.basePath}/${id}/claim`, input);

        return data;
    };
}
